module.exports = __webpack_public_path__ + "static/media/dokiaLogo.95f54922.png";